<template>
  <div class="index">
    <swiper ref="mySwiper" class="my_carousel" v-bind:options="swiperOptions">
      <swiper-slide v-for="(item,index) in bannerList" :key="index">
        <div class="img_div" style="height: 100%">
          <img :src="item.banner" width="100%" height="100%"/>
          <span class="bg_text" v-if="item.title1">
            <span>{{ item.title1 }}</span>
            <br>
            <span>{{ item.title2 }}</span>
          </span>
          <div v-if="item.url" class="but_div" @click="openHtml(item.url)" @mouseover="mu" @mouseleave="ml">
            查看详情
            <svg t="1695370100663" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4004" width="32"
                 height="32">
              <path
                  d="M853.333333 507.733333H128v42.666667h733.866667l-145.066667 145.066667 29.866667 29.866666 192-192L746.666667 341.333333l-29.866667 29.866667 136.533333 136.533333z"
                  :fill="jtcolor" p-id="4005"></path>
            </svg>
          </div>
          <div class="company_name" v-if="item.title==='装备展参展企业'">
            <div class="title_div">装备展参展企业</div>
            <span v-for="(item,index) in companyList" @click="openCompany(item)">{{ item.title }}</span>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <div id="information" class="app_common_lb">
      <el-row class="first_model" style="padding-top: 20px;padding-bottom: 0;">
        <el-col :span="12" style="position: relative;padding: 25px">
          <div class="title_div">
            <span class="title_name">
              <img src="~@/assets/images/index/right_sy.png" height="34" width="44"/>
              环境资讯
            </span>
            <router-link class="route_cla" :to="{ path: '/environmentalInformation'}">
              更多 >>
            </router-link>
          </div>
          <hr>
          <div class="content_div">
            <div class="yw_item" @click="toPage('informationDetail',284)">
              <div class="img_b">
                <img src="~@/assets/images/index/1-1.jpg" height="170px" width="100%"/>
              </div>
              <div class="bt_span">
                需方找到好技术，供方寻得大市场，山东举办挥发性有机物监测及治理技术供需对接会
              </div>
            </div>
            <div class="yw_item" @click="toPage('informationDetail',147)">
              <div class="img_b">
                <img src="~@/assets/images/index/1-2.jpg" height="170px" width="100%"/>
              </div>
              <div class="bt_span">
                山东省生态环境科技成果转化和环保产业<br>发展综合服务平台正式启动运行
              </div>
            </div>
            <div class="information_div" v-for="(item,index) in environmentalInformationList">
              <div :class="{'title':true,'first_title':index===0}" @click="toPage('informationDetail',item.id)">
                · <img src="~@/assets/images/index/new.gif" height="14" width="30" v-if="index===0"/>
                {{ item.indexTitle }}
              </div>
              <div class="time">[{{ item.fbTime }}]</div>
              <div class="content">{{ item.content }}</div>
            </div>
          </div>
        </el-col>
        <el-col :span="12" style="position: relative;padding: 25px">
          <div class="title_div">
            <span class="title_name">
              <img src="~@/assets/images/index/right_sy.png" height="34" width="44"/>
              行业资讯
            </span>
            <router-link class="route_cla" :to="{ path: '/industryInformation'}">
              更多 >>
            </router-link>
          </div>
          <hr>
          <div class="content_div">
            <div class="information_div" v-for="(item,index) in industryInformation">
              <div :class="{'title':true,'first_title':index===0}" @click="toPage('informationDetail',item.id)">
                · <img src="~@/assets/images/index/new.gif" height="14" width="30" v-if="index===0"/>
                {{ item.indexTitle }}
              </div>
              <div class="time">[{{ item.fbTime }}]</div>
              <div class="content">{{ item.content }}</div>
            </div>
            <div class="yw_item hy_yw_item" @click="toPage('informationDetail',359)">
              <div class="img_b">
                <img src="~@/assets/images/index/3.png" height="170px" width="100%"/>
              </div>
              <div class="bt_span">
                全省赤泥综合利用专班现场会议在淄博召开
              </div>
            </div>
            <div class="yw_item hy_yw_item" @click="toPage('informationDetail',310)">
              <div class="img_b">
                <img src="~@/assets/images/index/4.png" height="170px" width="100%"/>
              </div>
              <div class="bt_span">
                石晓鹏副厅长出席2023江苏省节能环保产业集群创新发展大会
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div id="policyFile" class="app_common_lb">
      <el-row class="first_model" style="padding-top: 0">
        <el-col :span="12" style="position: relative;padding: 25px">
          <div class="title_div">
            <span class="title_name">
              <img src="~@/assets/images/index/right_sy.png" height="34" width="44"/>
              产业政策
            </span>
            <router-link class="route_cla" :to="{ path: '/industryPolicy'}">
              更多 >>
            </router-link>
          </div>
          <hr>
          <div class="content_div">
            <div class="information_div cy_information_div" v-for="(item,index) in industrialPolicyList">
              <div :class="{'title':true,'first_title':index===0}" @click="openLink(item.link)">
                · <img src="~@/assets/images/index/new.gif" height="14" width="30" v-if="index===0"/>
                {{ item.title }}
              </div>
              <div class="time">[{{ item.fbTime }}]</div>
            </div>
          </div>
        </el-col>
        <el-col :span="12" style="position: relative;padding: 25px">
          <video controls width="100%" style="margin-top: 65px;">
            <source src="../../assets/video/video.mp4" type="video/mp4" style="width: 100%;margin-top: 52px;">
          </video>
        </el-col>
      </el-row>
    </div>
    <div id="technology" class="second_model">
      <div class="title">
        <!--        <span class="en_name">TECHNOLOGY COLLECTION</span>-->
        <span class="ch_name">
          技术成果
        </span>
      </div>
      <div class="js_p">
        <div class="js_item border_right border_left_02" @click="toTechnology('/technologyCollection',1)">
          <img src="~@/assets/images/index/swr.png"/>
          <div>水污染防治技术</div>
        </div>
        <div class="js_item border_right border_left_03" @click="toTechnology('/technologyCollection',12)">
          <img src="~@/assets/images/index/hyst.png"/>
          <div>海洋生态保护技术</div>
        </div>
        <div class="js_item border_right border_middle" @click="toTechnology('/technologyCollection',13)">
          <img src="~@/assets/images/index/dqwrfz.png"/>
          <div>大气污染防治技术</div>
        </div>
        <div class="js_item border_right border_left_03" @click="toTechnology('/technologyCollection',23)">
          <img src="~@/assets/images/index/gtfwclczjs.png"/>
          <div>固废处理处置技术</div>
        </div>
        <div class="js_item border_right_02" style="  border-bottom: 1px solid" @click="toTechnology('/technologyCollection',32)">
          <img src="~@/assets/images/index/trzlyxfjs.png"/>
          <div>土壤治理与修复技术</div>
        </div>
        <!--        <div class="js_item border_right border_right_02" @click="toTechnology('/technologyCollection',39)">
                  <img src="~@/assets/images/index/zswrkzjs.png"/>
                </div>
                <div class="js_item" @click="toTechnology('/technologyCollection',42)">
                  <img src="~@/assets/images/index/haqyfsxfzjs.png"/>
                </div>-->
        <div class="js_item border_right border_top border_left_02" @click="toTechnology('/technologyCollection',49)">
          <img src="~@/assets/images/index/zyhyzhlyjs.png"/>
          <div>资源综合利用技术</div>
        </div>
        <!--        <div class="js_item border_right border_top border_left_02" @click="toTechnology('/technologyCollection',54)">
                  <img src="~@/assets/images/index/qjscjs.png"/>
                </div>-->
        <div class="js_item border_right border_top border_left_03" @click="toTechnology('/technologyCollection',58)">
          <img src="~@/assets/images/index/stbhjs.png"/>
          <div>生态保护技术</div>
        </div>
        <div class="js_item border_right border_top border_middle" @click="toTechnology('/technologyCollection',63)">
          <img src="~@/assets/images/index/ydqhbh.png"/>
          <div>应对气候变化技术</div>
        </div>
        <div class="js_item border_right border_top border_right_03" @click="toTechnology('/technologyCollection',70)">
          <img src="~@/assets/images/index/hjjcyyjjs.png"/>
          <div>监测与预警技术</div>
        </div>
        <!--        <div class="js_item border_right border_top border_right_02" @click="toTechnology('/technologyCollection',80)">
                  <img src="~@/assets/images/index/hjjk.png"/>
                </div>
                <div class="js_item border_top border_right_01" @click="toTechnology('/technologyCollection',81)">
                  <img src="~@/assets/images/index/gyhyhjglzc.png"/>
                </div>-->

        <div class="js_item" @click="toTechnology('/technologyCollection',91)">
          <img src="~@/assets/images/index/sthjzlxms.png"/>
          <div>生态环境治理新模式</div>
        </div>
      </div>
    </div>
    <div id="demand" class="third_model">
      <div class="title">
        <span class="en_name">DEMAND INFORMATION</span>
        <span class="ch_name">需求信息</span>
      </div>
      <div class="xq_p">
        <el-row style="position: relative">
          <div class="more" @click="toPage('demandInfo')">
            更多需求
            <img src="~@/assets/images/index/more.png" height="14" width="14"/>
          </div>
          <template v-for="(item,index) in skilClassList" v-if="item.id === 1||item.id === 13||item.id === 23||item.id === 70">
            <el-col :span="6">
              <div class="content_p">
                <div class="img_div">
                  <img v-if="item.id===23" src="~@/assets/images/index/xq1.png" height="92" width="92"/>
                  <img v-if="item.id===70" src="~@/assets/images/index/xq2.png" height="92" width="92"/>
                  <img v-if="item.id===13" src="~@/assets/images/index/xq3.png" height="92" width="92"/>
                  <img v-if="item.id===1" src="~@/assets/images/index/xq4.png" height="92" width="92"/>
                </div>
                <div class="name_div" style="position: relative;top:40px" @click="toDemand(item.id)">
                  <span class="urgency" :key="index">{{ item.titleName }}</span>
                </div>
              </div>
            </el-col>
          </template>
        </el-row>
      </div>
    </div>
    <div id="achtrans" class="fourth_model">
      <div class="title">
        <span class="en_name">ACHIEVEMENT TRANSFORMATION</span>
        <span class="ch_name">成果转化</span>
      </div>
      <div class="img_p" style="height: 250px">
        <div class="h_div" @click="toPage('achtransList')">
          <div class="cgzh">成果列表</div>
          <!--          <img src="~@/assets/images/index/jishupinggu_bg.jpeg" width="100%"/>-->
        </div>
        <div class="h_div" @click="toPage('achtransUpload/0')">
          <div class="cgzh1">成果上传</div>
        </div>
        <div class="h_div" @click="toPage('convertorBase')">
          <div class="cgzh2">转移转化基地</div>
        </div>
        <!--        <div class="h_div" @click="toPage('achtransone')">
                  <img src="~@/assets/images/index/jishupinggu.png" width="100%"/>
                </div>
                <div class="h_div" @click="toPage('achtranstwo')">
                  <img src="~@/assets/images/index/jiaoyifuhua.png" width="100%"/>
                </div>
                <div class="h_div" @click="toPage('achtransthree')">
                  <img src="~@/assets/images/index/jishukaifa.png" width="100%"/>
                </div>-->
      </div>
    </div>
    <div id="assistanc" class="sixth_model">
      <div class="title">
        <span class="en_name">TECHNOLOGY ASSISTANCE</span>
        <span class="ch_name">科技帮扶</span>
      </div>
      <!--      <div class="td_p_div">
              <div class="td_item">
                <div class="td" @click="toAssistance(287)">
                  <img src="~@/assets/images/index/klwtd.png" height="90" width="90"/>
                  <div class="td_title">细颗粒物和臭氧污染协同调控省级团队</div>
                </div>
              </div>
              <div class="td_item">
                <div class="td" @click="toAssistance(285)">
                  <img src="~@/assets/images/index/hytd.png" height="90" width="90"/>
                  <div class="td_title">重点海域环境精准管控省级技术团队</div>
                </div>
              </div>
              <div class="td_item">
                <div class="td" @click="toAssistance(286)">
                  <img src="~@/assets/images/index/ssttd.png" height="90" width="90"/>
                  <div class="td_title">全省水生态环境质量提升技术帮扶团队</div>
                </div>
              </div>
              <div class="td_item">
                <div class="td" @click="toAssistance(288)">
                  <img src="~@/assets/images/index/dttd.png" height="90" width="90"/>
                  <div class="td_title">省低碳发展联盟</div>
                </div>
              </div>
              <div class="td_item">
                <div class="td" @click="toAssistance(335)">
                  <img src="~@/assets/images/index/nctd.png" height="90" width="90"/>
                  <div class="td_title">农业农村技术帮扶队伍</div>
                </div>
              </div>
            </div>-->
      <div class="img_p">
        <div class="div_img_p">
          <div class="div_img" v-for="(imgList,index1) in imgDataList" :key="index1" @click="toPage('assistance')">
            <img :src="imgList.img" width="100%" height="356.73px"/>
          </div>
        </div>
      </div>
    </div>
    <div class="fifth_model">
      <div class="fifth_sty_p">
        <div class="fifth_sty fifth_bg1">
          <div class="fifth_title">龙头企业</div>
          <div class="fifth_text">山东省龙头<br>骨干企业 ></div>
        </div>
      </div>
      <div class="fifth_sty_p">
        <div class="fifth_sty fifth_bg2">
          <div class="fifth_title">领军人物</div>
          <div class="fifth_text" style="color: #b68305">山东省生态环保产业<br>领军人物 ></div>
        </div>
      </div>
      <div class="fifth_sty_p">
        <div class="fifth_sty fifth_bg3">
          <div class="fifth_title">优秀人才</div>
          <div class="fifth_text">山东省生态环保产业<br>优秀人才 ></div>
        </div>
      </div>
      <div class="fifth_sty_p" @click="toPage('informationDetail',311)">
        <div class="fifth_sty fifth_bg4">
          <div class="fifth_title" style="margin-top: -20px">第三方治理<br>优秀工程</div>
          <div class="fifth_text" style="color: #656D62FF">山东省环境污染第三<br>方治理优秀工程 ></div>
        </div>
      </div>
      <div class="fifth_sty_p">
        <div class="fifth_sty fifth_bg5">
          <div class="fifth_title">创新团队</div>
          <div class="fifth_text">山东省生态环保产业<br>创新团队</div>
        </div>
      </div>
    </div>
    <div class="fuchuang wj" v-if="wjFlag">
      <div class="title" style="position: relative;top: 20px;font-size: 12px;text-align: center;">环保产业政策培育调查问卷
      </div>
      <img style="position: relative;top: 20px;" src="~@/assets/images/index/wjewm.png" width="100%"/>
      <i class="el-icon-close" @click="wjFlag=false"></i>
    </div>
    <div class="fuchuang expertAdd" v-if="expertAddFlag" @click="toPage('expertAdd')">
      <span style="position: absolute;width: 100%;text-align: center;height: 100%;line-height: 7;font-size: 20px;font-weight: 600;">专家团队</span>
      <img src="~@/assets/images/index/expertAdd.jpeg" width="100%" height="100%"/>
      <i class="el-icon-close" @click="expertAddFlag=false"></i>
    </div>
    <div class="fuchuang ewm" v-if="ewmFlag">
      <el-carousel indicator-position="outside">
        <el-carousel-item>
          <img src="~@/assets/images/index/jsq.png" width="100%"/>
        </el-carousel-item>
        <el-carousel-item>
          <img src="~@/assets/images/index/ewm.jpg" width="100%"/>
        </el-carousel-item>
        <el-carousel-item>
          <div class="ewm_p">
            <div class="title">公众号</div>
            <img src="~@/assets/images/index/gzh.jpg" width="100%"/>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="ewm_p">
            <div class="title">小程序</div>
            <img src="~@/assets/images/index/xcx.jpg" width="100%"/>
          </div>
        </el-carousel-item>
      </el-carousel>
      <i class="el-icon-close" @click="ewmFlag=false"></i>
    </div>
  </div>
</template>

<script>
import {listInformation} from "@/api/business/information";
import {listBanner} from "@/api/info/banner";
import {listTechnological} from "@/api/business/technological";
import {listDemand} from "@/api/business/demand";
import {listClass} from "@/api/info/skilClass";
import HeaderBar from "@/views/layout/components/HeaderBar";
import FooterBar from "@/views/layout/components/FooterBar";
import $ from 'jquery';
import {listMenu} from "@/api/business/nationalmenu";

window.$ = $
import {swiper, swiperSlide} from "vue-awesome-swiper";

export default {
  name: "index",
  components: {
    HeaderBar, FooterBar, swiper, swiperSlide
  },
  data() {
    return {
      skilClassList: [],
      jtcolor: '#333333',
      bannerList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 100,
        indexShow: '1'
      },
      environmentalInformationList: [],
      companyList: [],
      industryInformation: [],
      technologicalList: [],
      nationalCatalogueList: [],
      industrialPolicyList: [],
      demandList: [],
      baseUrl: process.env.VUE_APP_BASE_API,
      ewmFlag: true,
      gzhFlag: true,
      xcxFlag: true,
      expertAddFlag: true,
      wjFlag: true,
      imgDataList: [
        {
          img: require('@/assets/images/assistance/img/hy1.webp'),
        },
        {
          img: require('@/assets/images/assistance/img/hy2.webp'),
        },
        {
          img: require('@/assets/images/assistance/img/hy3.webp'),
        },
        {
          img: require('@/assets/images/assistance/img/hy4.webp'),
        },
        {
          img: require('@/assets/images/assistance/img/hy5.webp'),
        },
        {
          img: require('@/assets/images/assistance/img/dq1.webp'),
        },
        {
          img: require('@/assets/images/assistance/img/dq2.webp'),
        },
        {
          img: require('@/assets/images/assistance/img/hy1.webp'),
        },
        {
          img: require('@/assets/images/assistance/img/hy2.webp'),
        },
        {
          img: require('@/assets/images/assistance/img/hy3.webp'),
        },
        {
          img: require('@/assets/images/assistance/img/hy4.webp'),
        },
        {
          img: require('@/assets/images/assistance/img/hy5.webp'),
        },
        {
          img: require('@/assets/images/assistance/img/dq1.webp'),
        },
        {
          img: require('@/assets/images/assistance/img/dq2.webp'),
        }
      ],
      interval: {},
      swiperOptions: {
        loop: false,
        speed: 2000,
        effect: "fade",
        slidesPerView: "auto",
        observeParents: true,   //必须加入
        observer: true, //必须加入
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        },
        autoplay: {
          delay: 4000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
      },
    }
  },
  mounted() {
    this.getData();
    this.moveLeft();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    mu() {
      this.jtcolor = '#1460e8';
    },
    ml() {
      this.jtcolor = '#333333';
    },
    getData() {
      let queryParams = {
        pageNum: 1,
        pageSize: 3,
        indexShow: '1',
        type: '1',
        status: '正式',
      }
      listInformation(queryParams).then(response => {
        this.environmentalInformationList = response.rows;
        for (let i in this.environmentalInformationList) {
          let information = this.environmentalInformationList[i];
          if (information.content.length > 60) {
            information.content = information.content.substring(0, 60) + '...';
          }
        }
      })
      listInformation({
        pageNum: 1,
        pageSize: 15,
        type: '12'
      }).then(response => {
        this.companyList = response.rows;
      })
      queryParams.type = "2";
      listInformation(queryParams).then(response => {
        this.industryInformation = response.rows;
        for (let i in this.industryInformation) {
          let information = this.industryInformation[i];
          if (information.content.length > 60) {
            information.content = information.content.substring(0, 60) + '...';
          }
        }
      })
      listBanner(this.queryParams).then(response => {
        this.bannerList = response.rows;
      })
      queryParams.type = null;
      queryParams.status = null;
      listTechnological(queryParams).then(response => {
        this.technologicalList = response.rows;
      });
      queryParams.pageSize = 4;
      listDemand(queryParams).then(response => {
        this.demandList = response.rows;
      });
      listClass().then(response => {
        this.skilClassList = response.rows;
      });
      this.queryParams = {
        type: 2,
        policyType: 1,
        pageNum: 1,
        pageSize: 8
      }
      listMenu(this.queryParams).then(response => {
        this.industrialPolicyList = response.rows;
      });
      this.queryParams = {
        type: 1,
        policyType: null,
        pageNum: 1,
        pageSize: 6
      }
      listMenu(this.queryParams).then(response => {
        this.nationalCatalogueList = response.rows;
      });
    },
    toPage(url, id) {
      if (id) {
        this.$router.push({path: url + "/" + id})
      } else {
        this.$router.push({path: url})
      }
    },
    toAssistance(val) {
      this.$router.push({path: '/assistance', query: {activeType: val}})
    },
    openHtml(url) {
      if (url.indexOf('http') > -1) {
        window.open(url);
      } else {
        this.$router.push({path: url})
      }

    },
    toTechnology(url, id) {
      this.$router.push({path: url, query: {id: id}})
    },
    openCompany(item) {
      if (item.indexShow != 1) {
        return;
      }
      let newTab = this.$router.resolve({path: 'informationDetail' + "/" + item.id})
      window.open(newTab.href, '_blank');
    },
    moveLeft() {
      let lf = 0;
      let that = this;
      that.interval = setInterval(function () {
        lf -= 1
        $(".div_img_p").css("left", lf + "px");
        if (lf % (470 * 7) === 0) {
          lf = 0;
        }
      }, 10)
    },
    toDemand(id) {
      this.$router.push({path: 'demandInfo', query: {id: id}})
    },
    openLink(url) {
      window.open(url, '_blank');
    },
  }
}
</script>

<style scoped lang="scss">
.index {
  .img_div {
    position: relative;

    .bg_text {
      font-size: 2.9vw;
      font-family: Microsoft YaHei;
      font-weight: 700;
      color: #FFFFFF;
      text-shadow: 0 5px 10px #104D83;
      position: absolute;
      top: 16.5vw;
      left: 10%;
    }

    .first_row {
      font-size: 59px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      text-shadow: 0 3px 6px #104D83;
      position: absolute;
      top: 364px;
      left: 10%;
    }

    .second_row {
      font-size: 59px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #FFFFFF;
      text-shadow: 0 3px 6px #104D83;
      position: absolute;
      top: 456px;
      left: 10%;
    }

    .but_div {
      width: 279px;
      height: 71px;
      line-height: 71px;
      padding-left: 30px;
      background: #FFFFFF;
      border-radius: 35px;
      position: absolute;
      top: 70%;
      left: 10%;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      cursor: pointer;

      svg {
        position: relative;
        top: 10px;
        left: 30px;
      }
    }

    .but_div:hover {
      color: #1460e8;
    }
  }

  .cgzh {
    background-image: url('~@/assets/images/index/jishupinggu_bg.jpeg');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 463px;
    height: 250px;
    color: #fff;
    font-weight: 600;
    font-size: 35px;
    line-height: 250px;
    font-font: Microsoft YaHei;
  }

  .cgzh1 {
    background-image: url('~@/assets/images/index/jiaoyifuhua_bg.jpeg');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 463px;
    height: 250px;
    color: #fff;
    font-weight: 600;
    font-size: 35px;
    line-height: 250px;
    font-font: Microsoft YaHei;
  }

  .cgzh2 {
    background-image: url('~@/assets/images/index/jishukaifa_bg.jpeg');
    background-repeat: no-repeat;
    background-size: 100% 100%;;
    width: 463px;
    height: 250px;
    color: #fff;
    font-weight: 600;
    font-size: 35px;
    line-height: 250px;
    font-font: Microsoft YaHei;
  }

  .divSrc {
    //width: 403px;
    height: 320px;
    background: #fff;
    margin-right: 26px;
    display: flex;
    flex-flow: row;
    justify-content: space-between;

    img {
      width: 100%;
      height: 100%;
    }

    .div_img {
      width: 450px;
      height: 320px;
    }

    .title {
      width: 90%;
      height: 80px;
      line-height: 80px;
      margin: 0 auto;
      text-align: center;

      font-size: 20px;
      font-weight: bold;
      color: #222222;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .information_div {
    height: 83px;
    cursor: pointer;

    .title {
      font-size: 18px;
      font-family: Microsoft YaHei;
      color: #000000;
      width: 80%;
      font-weight: 500;
      float: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .first_title {
      color: #034cc6;
    }

    .time {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      width: 20%;
      display: inline-block;
      text-align: right;
    }

    .content {
      height: 50px;
      width: 100%;
      font-size: 14px;
      color: #999999;
      display: -webkit-box;
      -webkit-line-clamp: 1.5;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 7px;
    }
  }

  .cy_information_div {
    height: 50px;
  }

  .first_model {
    padding: 50px 0;

    .title_div {
      .title_name {
        font-size: 30px;
        font-family: MicrosoftYaHei;
        font-weight: bold;
        color: #2874E0;
        line-height: 39px;

        background: linear-gradient(262deg, #2773E0 0%, #35BC7B 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;

        img {
          position: relative;
          top: 6px;
        }
      }
    }

    hr {
      display: block;
      border: 0;
      width: 100%;
      height: 3px;
      background: linear-gradient(262deg, #2773E0, #35BC7B);
    }
  }

  .second_model, .third_model, .fourth_model, .sixth_model {
    .title {
      width: 100%;
      margin: 0 auto;
      text-align: center;
      position: relative;
      padding: 35px 0;

      .en_name {
        font-size: 75px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        opacity: 0.4;
        color: #84C227;
        line-height: 203px;

        background: linear-gradient(262deg, #2773E0 0%, #35BC7B 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }

      .ch_name {
        width: 250px;
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        position: absolute;
        color: #FFFFFF;
        top: 43%;
        left: 43.5%;
      }


      .ch_name::before {
        content: "----";
        background-image: url('~@/assets/images/index/left_sy.png');
        background-repeat: no-repeat;
        background-size: contain;
        width: 100px;
        height: 100px;
        color: rgba(247, 248, 249, 0);
      }

      .ch_name::after {
        content: "----";
        background-image: url('~@/assets/images/index/right_sy.png');
        background-repeat: no-repeat;
        background-size: contain;
        width: 100px;
        height: 100px;
        color: rgba(247, 248, 249, 0);
      }
    }
  }

  .second_model {
    .title {
      height: 237px;
    }
  }

  .third_model, .fourth_model, .sixth_model {
    .ch_name {
      text-shadow: 1px 1px 5px #088402, 1px 1px 10px #088402, 1px 1px 20px #088402, 1px 1px 30px #088402, 1px 1px 40px #088402;
    }
  }

  .information_div:hover {
    .title, .time {
      color: #2874E0 !important;
    }
  }

  .second_model {
    height: 759px;
    background: url("~@/assets/images/index/jishuhuijibg.png") no-repeat;
    background-size: 100% 100%;

    .title {
      .en_name {
        color: #FFFFFF;
      }

      .ch_name {
        color: #FFFFFF;
      }
    }

    .js_p {
      width: 1400px;
      margin: 0 auto;

      .js_item {
        display: inline-block;
        width: 280px;
        height: 200px;
        text-align: center;
        cursor: pointer;
        padding: 50px 0;

        img {
          width: 50px;
          height: 50px;
        }

        div {
          color: #ffffff;
          font-size: 20px;
          padding-top: 20px;
        }
      }

      .border_right {
        border-right: 1px solid
      }

      .border_top {
        border-top: 1px solid
      }

      .border_left_01 {
        border-image: linear-gradient(to right, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.3)) 1;
      }

      .border_right_01 {
        border-image: linear-gradient(to left, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.3)) 1;
      }

      .border_left_02 {
        border-image: linear-gradient(to right, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.4)) 1;
      }

      .border_right_02 {
        border-image: linear-gradient(to left, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.4)) 1;
      }

      .border_left_03 {
        border-image: linear-gradient(to right, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.6)) 1;
      }

      .border_right_03 {
        border-image: linear-gradient(to left, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.6)) 1;
      }

      .border_left_04 {
        border-image: linear-gradient(to right, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.8)) 1;
      }

      .border_right_04 {
        border-image: linear-gradient(to left, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.8)) 1;
      }

      .border_middle {
        border-image: linear-gradient(to left, rgba(255, 255, 255, 0.8), #ffffff, rgba(255, 255, 255, 0.8)) 1;
      }

      .js_item:hover {
        background: rgba(0, 0, 0, 0.3);
      }
    }
  }

  .third_model, .fourth_model, .sixth_model {
    .title {
      .en_name {
        color: #84C227;
      }
    }

    .xq_p {
      width: 1300px;
      margin: 0 auto;

      .content_p {
        width: 290px;
        height: 290px;
        border: 1px solid #d0d0d0;
        border-radius: 5px;
        box-shadow: 0 0 15px #d0d0d0;
        margin: 0 auto;
        text-align: center;

        .img_div {
          margin-top: 40px;
        }

        .name_div {
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #333333;
          margin-top: 10px;
          cursor: pointer;
        }

        .lb {
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          margin-top: 10px;
        }

        .ly {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          margin-top: 10px;
        }

        .more {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 300;
          color: #999999;
          margin-top: 10px;
          cursor: pointer;
        }
      }

      .content_p:hover {
        box-shadow: 0 0 15px #6f83ff;
      }

      .more:hover, .name_div:hover {
        color: #2773E0;
      }

      .more {
        position: absolute;
        top: -28px;
        text-align: right;
        color: #333;
        cursor: pointer;
        right: 2%;

        img {
          position: relative;
          top: 2px;
        }
      }
    }
  }

  .fourth_model {
    .img_p {
      width: 1400px;
      margin: 0 auto;
      text-align: center;
      overflow: hidden;

      .h_div {
        width: 33%;
        height: 250px;
        cursor: pointer;
        overflow: hidden;
        display: inline-block;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .h_div:hover {
        div {
          transform: scale(1.2);
          transition: all 0.3s ease-in-out;
        }
      }
    }
  }

  .fifth_model {
    display: flex;
    flex-flow: row;
    width: 1400px;
    justify-content: space-between;
    flex-wrap: nowrap;
    //width: 100%;
    margin: 20px auto;
    height: 149px;

    .fifth_bg1 {
      background: url("~@/assets/images/index/fifth_bg_bqqy.jpg") no-repeat;
      background-size: 100% 100%;
    }

    .fifth_bg2 {
      background: url("~@/assets/images/index/fifth_bg_ljrw.jpg") no-repeat;
      background-size: 100% 100%;
    }

    .fifth_bg3 {
      background: url("~@/assets/images/index/fifth_bg_yxrc.jpg") no-repeat;
      background-size: 100% 100%;
    }

    .fifth_bg4 {
      background: url("~@/assets/images/index/fifth_bg_dsfyxzlgc.jpg") no-repeat;
      background-size: 100% 100%;
    }

    .fifth_bg5 {
      background: url("~@/assets/images/index/fifth_bg_cxtd.jpg") no-repeat;
      background-size: 100% 100%;
    }

    .fifth_sty_p {
      cursor: pointer;
      display: inline-block;
      width: 267px;
      height: 100%;
      overflow: hidden;

      .fifth_sty {
        width: 267px;
        height: 100%;
        padding-top: 26px;
        padding-left: 18px;
        padding-right: 80px;
        display: flex;
        flex-flow: column;

        .fifth_title {
          width: 100%;
          margin-top: 11px;
          font-size: 30px;
          font-family: emoji;
          font-weight: 800;
          color: #ffffffdb;
          text-shadow: 0px 3px 4px rgba(0, 0, 0, 0.2);
        }

        .fifth_text {
          width: 100%;
          margin-top: 13px;
          height: 33px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #ffffffb5;
          line-height: 18px;

        }
      }
    }

    .fifth_sty_p:hover {
      .fifth_sty {
        transform: scale(1.1);
        transition: all 0.3s ease-in-out;
      }
    }
  }

  .sixth_model {
    .img_p {
      width: 1400px;
      margin: 0 auto;
      text-align: center;
      overflow: hidden;
      height: 350px;
      white-space: nowrap;

      .div_img_p {
        position: relative;
        cursor: pointer;

        .div_img {
          width: 470px;
          display: inline-block;
        }
      }
    }

    .td_p_div {
      width: 1400px;
      margin: 0 auto;
      display: flex;

      .td_item {
        flex: 1;
        height: 200px;

        .td {
          width: 90%;
          height: 100%;
          margin: 0 5%;
          border: 1px solid #d0d0d0;
          border-radius: 5px;
          box-shadow: 0 0 15px #d0d0d0;
          cursor: pointer;
          padding: 25px;
          text-align: center;

          .td_title {
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #333333;
            margin-top: 10px;
            cursor: pointer;
            text-align: center;
          }
        }

        .td:hover {
          box-shadow: 0 0 15px #6f83ff;

          .td_title {
            color: #2773E0;
          }
        }
      }
    }
  }

  .ewm_p {
    background: #ffffff;
    width: 150px;
    height: 196px;
    //display: flex;
    //justify-content: center;
    //align-items: center;
    .title {
      width: 100%;
      text-align: center;
      padding: 10px;
    }
  }

  .fuchuang {
    width: 150px;
    box-shadow: 0 0 15px #d0d0d0;
    position: fixed;
    z-index: 5;

    i {
      position: absolute;
      top: 5px;
      right: 5px;
      z-index: 6;
      cursor: pointer;
    }
  }

  .fuchuang:hover {
    box-shadow: 0 0 15px #6f83ff;
  }

  .wj {
    height: 190px;
    bottom: 348px;
    right: 0;
    background: #FFFFFF;
  }

  .expertAdd {
    height: 145px;
    bottom: 200px;
    right: 0;
  }

  .ewm {
    height: 197px;
    bottom: 0;
    right: 0;
  }

  .xcx {
    height: 150px;
    bottom: 170px;
    left: 0;
  }

  .gzh {
    height: 168px;
    padding-top: 18px;
    background-color: #fff;
    bottom: 0;
    left: 0;
  }


  .yw_item {
    display: inline-table;
    width: 48%;
    border-radius: 5px;
    box-shadow: 0 0 15px #d0d0d0;
    margin: 1% 1% 4% 1%;

    .img_b {
      overflow: hidden;
      width: 100%;
      height: 170px;

      img:hover {
        transform: scale(1.1);
        transition: all 0.3s ease-in-out;
      }
    }

    .bt_span {
      width: 100%;
      height: 60px;
      font-weight: 600;
      font-size: 15px;
      color: #333;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 5px;
    }
  }

  .hy_yw_item {
    margin: 4% 1% 1% 1%;
  }
}
</style>
<style lang="scss">
.route_cla {
  position: absolute;
  top: 40px;
  right: 40px;
  cursor: pointer;
  z-index: 4;
  color: #3c9bf1;

  img {
    position: relative;
    top: 2px;
  }
}

.route_cla:hover {
  color: #034186;
}

.my_tab {
  position: relative;


  .el-tabs__item {
    font-size: 30px;
    font-family: Microsoft YaHei;
    color: #000000;
    font-weight: bold;
  }

  .el-tabs__active-bar {
    background: #d4d4d4;
  }
}

.my_carousel {
  height: 100vh !important;

  .company_name {
    position: absolute;
    bottom: 1vw;
    color: #ffffff;
    font-size: 1vw;
    cursor: pointer;
    padding: 35px 3vw;

    .title_div {
      text-align: center;
      font-size: 1.45vw;
      margin-bottom: 1.45vw;
    }

    span {
      display: inline-block;
      width: 18.5vw;
      padding: 20px 0;
      text-align: left;
    }

    span:hover {
      color: #3c9bf1;
    }
  }
}

.swiper {
  width: 100%;
  padding-top: 50px;
  padding-bottom: 50px;
}

.swiper-slide {
  background-position: center;
  background-size: cover;
  height: 100%;
}

.swiper-slide img {
  display: block;
  width: 100%;
}

.swiper-pagination {
  position: absolute;
  bottom: 0;
}
</style>
